import { render, staticRenderFns } from "./CityList.vue?vue&type=template&id=2358801a&scoped=true&"
import script from "./CityList.vue?vue&type=script&lang=js&"
export * from "./CityList.vue?vue&type=script&lang=js&"
import style0 from "./CityList.vue?vue&type=style&index=0&id=2358801a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2358801a",
  null
  
)

export default component.exports